import React from 'react';
import { CssBaseline, Grid, Typography, withStyles } from '@material-ui/core';
import LiveTopbar from '../components/LiveTopbar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { BBS_API_URL, EVENT_ID, getUserID, LOGIN_TB, MQ_URL, NOTICE_EMERGENCY, SIGNOUT_URL, WEBSOCKET_URL } from '../constants';

import queryString from 'querystring';
import Stomp from 'stompjs';
import axios from 'axios';
import { Auth } from 'aws-amplify';
import swal from 'sweetalert';
import ChatView from './sessionComp/ChatView';

const styles = (theme) => ({
  container: {
    display: 'flex',
    backgroundColor: 'white',
    //height: 'calc(100% - 48px)',
    '@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none)': {
      height: 'calc(100% - 81px - 48px)',
    },
    [theme.breakpoints.down('sm')]: {
      height: 'auto',
    },
    '& .MuiTypography-root': {
      padding: '0px !important',
    },
  },
  main: {
    height: 'calc(100vh - 92px)',
    '@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none)': {
      height: '100%',
    },
    // overflowY: 'auto',
  },
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  footer: {
    backgroundColor: '#ffffff',
    position: 'relative',
    width: '100%',
    marginLeft: '90px',
  },
  rightWrap: {
    [theme.breakpoints.down('sm')]: {
      borderLeft: 'none',
      // height: '80%',
    },
  },
  tabContainer: {
    [theme.breakpoints.down('sm')]: {
      height: 'auto',
    },
  },
  tabPanel: {
    height: '75vh',
    [theme.breakpoints.down('sm')]: {
      height: 'auto',
    },
  },
  bannerContainer: {
    backgroundColor: '#fff',
    height: '100%',
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },

  //동영상영역
  videoGrid: {
    height: 'calc(100vh - 164px)',
    borderRight: '1px solid #f5f5f5',
    [theme.breakpoints.down('sm')]: {
      height: '100%',
    },
  },
  bottoms: {
    [theme.breakpoints.up('md')]: {
      // position: 'absolute',
      bottom: 0,
      left: 0,
      zIndex: 999,
    },
  },
  buttons: {
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  //우측하단 버튼 영역
  bottomBtns: {
    borderTop: '1px solid #f5f5f5',
    height: '6%',
    padding: '1em 0',
    backgroundColor: '#ffffff',

    '& div': {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      cursor: 'pointer',
      color: '#d54a50',
      fontWeight: 'bold',
    },
  },
  moveChannel: {
    textAlign: 'center',
    [theme.breakpoints.down('lg')]: {
      display: 'flex',
      flexDirection: 'column',
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '0.9em',
      flexDirection: 'row',
    },
    '& br': {
      display: 'none',
      [theme.breakpoints.down('lg')]: {
        display: 'block',
      },
    },
  },
  moveWeb: {
    flexDirection: 'column',
    [theme.breakpoints.down('sm')]: {
      display: 'none !important',
    },
  },
  moveMob: {
    display: 'none !important',
    [theme.breakpoints.down('sm')]: {
      display: 'block !important',
    },
  },
  //배너영역
  adWeb: {
    display: 'flex',
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  adMob: {
    display: 'flex',
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
});

function TabContainer(props) {
  return (
    <Typography component="div" style={{ padding: 8 * 3, backgroundColor: '#ffffff' /*, height: '100%' */ }}>
      {props.children}
    </Typography>
  );
}

class LiveChatPage extends React.Component {
  constructor(props) {
    super(props);
    let param = queryString.parse(this.props.location.search.replace('?', ''));

    this.refChat = React.createRef();
    this.refLiveTopBar = React.createRef();
    this.refMain = React.createRef();

    this.state = {
      value: 0,
      date1: false,
      date2: false,
      date3: false,
      date1Hovered: false,
      date2Hovered: false,
      date3Hovered: false,
      msg: '',
      channelId: param.ch,
      openAttendPopup: true,
      username: sessionStorage.getItem('_in_name'),
      openConfirmPopup: false,
      now: new Date(),
      openEmergencyPopup: false,
      openProgramDialog: false,
      openAttendCheckDialog: false,
      noticeContent: '',
      noticeTitle: '',
      session: '',
    };

    this.handleDate = this.handleDate.bind(this);
    this.handleHover = this.handleHover.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.liveLogout = this.liveLogout.bind(this);
    this.doClose = this.doClose.bind(this);
    this.moveRoom = this.moveRoom.bind(this);
    //this.init = this.init.bind(this);
    //this.popupNoti = this.popupNoti(this);
  }

  socketManager() {
    console.log('>>> socketManger <<<');

    let socket = new WebSocket(WEBSOCKET_URL);
    this.setState({ mainSocket: socket });

    if (!sessionStorage.getItem('_in_user_')) {
      this.props.history.push('/');
    }
    socket.onopen = (event) => {
      console.log('socket open');
      if (sessionStorage.getItem('_in_user_')) {
        const _in_ = sessionStorage.getItem('_in_user_');
        console.log('socket >> ' + _in_);
        socket.send(JSON.stringify({ action: 'sendmessage', type: 'join', room: _in_, evt: EVENT_ID }));
        console.log('socket send >> ' + sessionStorage.getItem('_in_event_id'));
        socket.send(
          JSON.stringify({ action: 'sendmessage', type: 'msg', room: _in_, evt: EVENT_ID, data: sessionStorage.getItem('_in_event_id') }),
        );
        socket.send(
          JSON.stringify({
            action: 'sendmessage',
            type: 'msg',
            room: _in_ + '_Live',
            evt: EVENT_ID,
            data: sessionStorage.getItem('_in_event_id'),
          }),
        );
      }
    };
    socket.onmessage = (event) => {
      console.log('onmessage ');
      // console.log(event);
      // console.log(event.data + "/" + sessionStorage.getItem("_in_event_id"));
      if (sessionStorage.getItem('_in_event_id') && event.data !== sessionStorage.getItem('_in_event_id')) {
        console.log('중복로그인 >>');
        swal('', '중복로그인이 되어 로그아웃됩니다.', 'warning');
        localStorage.clear();
        sessionStorage.clear();
        Auth.signOut().then(() => {
          window.opener = 'Self';
          window.close(); // 일반적인 현재 창 닫기
          // window.open('', '_parent', '');
          // window.open('about:blank', '_self').self.close(); // IE에서 묻지 않고 창 닫기
        });
      }
    };
    socket.onclose = (event) => {
      console.log('onclose', sessionStorage.getItem('_in_user_'));
      if (sessionStorage.getItem('_in_user_')) {
        const _in_ = sessionStorage.getItem('_in_user_');
        console.log(_in_);
        // this.setState({ mainSocket: new WebSocket(WEBSOCKET_URL) });
        // this.socketManager(this.state.mainSocket);
        this.socketManager();
      }
    };
    socket.onerror = (event) => {
      console.log('onerror', event);
    };
  }

  componentDidMount() {
    this.socketManager();
    window.addEventListener('beforeunload', this.onBeforeUnload);
    this.init();
  }

  componentWillUnmount() {
    if (this.state.mainSocket) {
      this.state.mainSocket.close();
      delete this.state.mainSocket;
      //console.log('>>> socketRelease <<<');
      this.setState({ mainSocket: null });
    }
    window.removeEventListener('beforeunload', this.onBeforeUnload);
  }

  onBeforeUnload = (e) => {
    if (!sessionStorage.getItem('_in_user_')) {
      return;
    }
    try {
      this.refLiveTopBar.current.goExit();
    } catch (err) {}

    e.preventDefault();
    const confirmationMessage = `강의창 종료 전, '이수하기'버튼을 클릭하셔야 퇴장시간 확인이 가능합니다. 종료하시겠습니까?`;
    (e || window.event).returnValue = confirmationMessage; //Gecko + IE, Chrome(mac os)

    return confirmationMessage; //Gecko + Webkit, Safari, Chrome etc.
  };

  init() {
    const eventItem = sessionStorage.getItem('Item');
    let jsonItem = null;
    if (!eventItem) this.props.history.push('/main');
    else {
      jsonItem = JSON.parse(eventItem);
      console.log('jsonItem', jsonItem);
      const pos = jsonItem.channel
        .map(function (e) {
          return e.name;
        })
        .indexOf(this.state.channelId);
      this.setState({ channel: jsonItem.channel }, () => {
        console.log('CHANNEL: ', this.state.channel);
      });
      this.setState({ callFunction: pos /*+ 1*/ }, () => {
        console.log('callFunc', this.state.callFunction);
      });
    }
    this.mqConnect();
  }

  liveLogout() {
    this.setState({ openConfirmPopup: true, isShowConfirm: true });
  }

  mqConnect = () => {
    const random = Math.random().toFixed(3).split('.')[1];
    const headers = {
      login: 'atozsoft',
      passcode: 'atozsoft0901',
      'client-id': sessionStorage.getItem('_in_sub') + random,
    };
    const CH = this.state.channelId;
    let that = this;
    let client = null;
    let mqNo = 1;
    client = Stomp.client(MQ_URL);
    this.setState({ MQ: 1 });

    client.connect(
      headers,
      function () {
        console.log(mqNo + '<< connect', new Date());

        client.subscribe(
          '/topic/' + EVENT_ID + '_' + CH,
          function (data) {
            console.log(data);
            console.log(JSON.parse(data.body));
            // eslint-disable-next-line
            let buff = JSON.parse(data.body);
            if (data.command === 'MESSAGE') {
              let cData = JSON.parse(data.body);
              let cate = cData.status;
              switch (cate) {
                case NOTICE_EMERGENCY:
                  axios
                    .get(`${BBS_API_URL}/notice/info?evt=${EVENT_ID}&noticeId=${cData.data}`, { headers: { Pragma: 'no-cache' } })
                    .then((response) => {
                      that.setState({
                        openEmergencyPopup: true,
                        noticeTitle: response.data.Item.noticeTitle,
                        noticeContent: response.data.Item.noticeContents,
                      });
                      console.log(response);
                    });
                  break;
                default:
                  break;
              }
            }
          },
          headers,
        );
      },
      function (err) {
        console.log('error', err);
        that.mqConnect();
      },
    );

    client.heartbeat.outgoing = 20000; // client will send heartbeats every 20000ms
    client.heartbeat.incoming = 0;
    client.reconnect_delay = 5000;
    client.debug = function (str) {};
  };

  doClose(event, _val) {
    if (_val === 'Y') {
      try {
        this.refLiveTopBar.current.goExit();
      } catch (err) {
        console.log(err);
      }

      setTimeout(function () {
        if (sessionStorage.getItem('_in_name')) {
          fetch(
            `${SIGNOUT_URL}?username=${encodeURIComponent(
              sessionStorage.getItem('_in_name'),
            )}&userid=${getUserID()}&evt=${EVENT_ID}&tbName=${LOGIN_TB}&agent=${encodeURIComponent(navigator.userAgent)}`,
            {
              method: 'GET',
            },
          )
            .then(() => {})
            .catch((err) => {
              console.log(err);
            });
        }

        localStorage.clear();
        sessionStorage.clear();
        Auth.signOut().then(() => {
          window.opener = 'Self';
          window.close(); // 일반적인 현재 창 닫기
          // window.open('', '_parent', '');
          // window.open('about:blank', '_self').self.close(); // IE에서 묻지 않고 창 닫기
        });
      }, 1000);
    } else {
      this.setState({ openConfirmPopup: false });
    }
  }

  handleUnload() {
    return 'exit';
  }

  handleChange(event, newVal) {
    //console.log(newVal);
    this.setState({ value: newVal });
  }

  handleHover(e) {
    const strId = e.target.id + 'Hovered';
    this.setState({
      [strId]: true,
    });
  }

  closeEmergencyDialog = (event) => {
    this.setState({ openEmergencyPopup: false });
  };

  closeAttendDialog = (event) => {
    this.setState({ openAttendPopup: false });
  };

  closeProgramDialog = (event) => {
    this.setState({ openProgramDialog: false });
  };

  closeAttendCheckDialog = (event) => {
    this.setState({ openAttendCheckDialog: false });
  };

  handleDate(e, idx) {
    for (let i = 1; i <= 3; i++) {
      this.setState({ ['date' + i]: false });
    }
    this.setState({ [idx]: true });
  }

  onSetSession = (session) => {
    if (this.state.session !== session) {
      this.refChat.current.clearChatList();
    }

    this.setState({ session: session });
  };

  handleState(key, value) {
    this.setState((prevState) => ({
      [key]: value,
    }));
  }

  moveRoom(ch) {
    // this.setState({ opened: true });
    if (this.state.win) {
      this.state.win.close();
    }

    if (ch === 'ChannelA') {
      this.setState({ channelId: 'ChannelB' }, () => {
        console.log('현재 접속한 방: ' + this.state.channelId);
      });

      window.location.href = `/#/live?ch=ChannelB`;
      window.location.reload();
    } else {
      this.setState({ channelId: 'ChannelA' }, () => {
        console.log('현재 접속한 방: ' + this.state.channelId);
      });
      window.location.href = `/#/live?ch=ChannelA`;
      window.location.reload();
    }
    // setTimeout(() => {
    //   this.refTopBar.current.refreshTitle(ch);
    // }, 500);
  }

  render() {
    const { classes } = this.props;
    const { value } = this.state;

    return (
      <React.Fragment>
        <div style={{ height: '100%', overflow: 'auto' }}>
          <CssBaseline />
          <LiveTopbar
            ref={this.refLiveTopBar}
            ch={this.state.channelId}
            callFunc={this.state.callFunction}
            setSession={this.onSetSession}
            chatOnly={true}
            handleState={this.handleState.bind(this)}
          />
          <main className={classes.main}>
            <div
              className={classes.container}
              style={
                navigator.userAgent.toLowerCase().indexOf('msie') !== -1 ||
                navigator.userAgent.toLowerCase().indexOf('ie') !== -1 ||
                navigator.userAgent.toLowerCase().indexOf('trident') !== -1
                  ? { height: 'calc(100% - 81px - 113px)' }
                  : {}
              }
            >
              {/* End hero unit */}
              <Grid container spacing={0}>
                <Grid item xs={12} className={classes.rightWrap}>
                  <Tabs value={value} indicatorColor="primary" textColor="primary" aria-label="tabs" onChange={this.handleChange}>
                    <Tab label={`${this.state.channelId}`} style={{ minWidth: '100px', fontWeight: 'bold' }} />
                  </Tabs>

                  {value === 0 && (
                    <TabContainer>
                      <ChatView ref={this.refChat} channel={this.state.channelId} session={this.state.session} chatOnly={true} />
                    </TabContainer>
                  )}
                </Grid>
              </Grid>
            </div>
          </main>
        </div>
      </React.Fragment>
    );
  }
}

export default withStyles(styles, { withTheme: true })(LiveChatPage);
